// Constants extracted from Services.js

import _ from "lodash";
import { colors } from "Constants";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";

export const STANDARD_UIDS = {
  [CURRICULUM_TYPE_PYP]: "benchmarks",
  [CURRICULUM_TYPE_UBD]: "learningStandardUBD",
  [CURRICULUM_TYPE_MYP]: "learningStandardMYP",
  [CURRICULUM_TYPE_DP]: "subjectStandardDP",
};

// Constants
export const NAME = "app_services";
export const SET_IS_ONLINE = "SET_IS_ONLINE" + " " + NAME;
export const SET_IS_PAGE_NOT_FOUND = "SET_IS_PAGE_NOT_FOUND" + " " + NAME;
export const SET_IS_AI_USAGE_LIMIT_MODAL =
  "SET_IS_AI_USAGE_LIMIT_MODAL" + " " + NAME;
export const SET_PROGRESS = "SET_PROGRESS" + " " + NAME;
export const REMOVE_PROGRESS_ELEMENT = "REMOVE_PROGRESS_ELEMENT" + " " + NAME;
export const UPDATE_LOCAL_COMMENT = "UPDATE_LOCAL_COMMENT" + " " + NAME;
export const INITIALISE_RESOURCEBANK_COMPONENT =
  "INITIALISE_RESOURCEBANK_COMPONENT" + " " + NAME;
export const UPDATE_RESOURCEBANK_FILTERS =
  "UPDATE_RESOURCEBANK_FILTERS" + " " + NAME;
export const TOGGLE_RESOURCEBANK_FILTER_ITEM =
  "TOGGLE_RESOURCEBANK_FILTER_ITEM" + " " + NAME;
export const TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS =
  "TOGGLE_ALL_RESOURCE_FILTER_ITEMS" + " " + NAME;
export const TOGGLE_RESOURCEBANK_SELECTED_RESOURCES =
  "TOGGLE_RESOURCEBANK_SELECTED_RESOURCES" + " " + NAME;
export const CLEAR_RESOURCEBANK_SELECTED_RESOURCES =
  "CLEAR_RESOURCEBANK_SELECTED_RESOURCES" + " " + NAME;
export const SET_ORDER_BY_DIRECTION = "SET_ORDER_BY_DIRECTION" + " " + NAME;
export const TOGGLE_ACTION_LOADING = "TOGGLE_ACTION_LOADING" + " " + NAME;
export const UPDATE_AUDIO_RECORDER_BLOB =
  "UPDATE_AUDIO_RECORDER_BLOB" + " " + NAME;
export const SET_PICTURE_IN_PICTURE_DATA =
  "SET_PICTURE_IN_PICTURE_DATA" + " " + NAME;
export const UPDATE_GLOBAL_SEARCH_TEXT = `UPDATE_GLOBAL_SEARCH_TEXT ${NAME}`;
export const SET_GLOBAL_SEARCH_VOICE = `SET_GLOBAL_SEARCH_VOICE ${NAME}`;
export const SET_GLOBAL_SEARCH_MODAL = `SET_GLOBAL_SEARCH_MODAL ${NAME}`;
export const SET_GLOBAL_SEARCH_FILTER_MODULE = `SET_GLOBAL_SEARCH_FILTER_MODULE ${NAME}`;
export const TOGGLE_GLOBAL_SEARCH_MODULE = `TOGGLE_GLOBAL_SEARCH_MODULE ${NAME}`;
export const TOGGLE_GLOBAL_SEARCH_VOICE_MODULE = `TOGGLE_GLOBAL_SEARCH_VOICE_MODULE ${NAME}`;
export const TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE = `TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE ${NAME}`;
export const SET_GLOBAL_SEARCH_COURSES_CONTEXT = `SET_GLOBAL_SEARCH_COURSES_CONTEXT ${NAME}`;
export const SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT = `SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT ${NAME}`;
export const SET_JUMP_TO_CURRICULUM_CONTEXT = `SET_JUMP_TO_CURRICULUM_CONTEXT ${NAME}`;
export const SET_UBD_ASSESSMENT_TYPES = `SET_UBD_ASSESSMENT_TYPES ${NAME}`;
export const SHOW_INTERCOM = `SHOW INTERCOM ${NAME}`;
export const HIDE_INTERCOM = `HIDE INTERCOM ${NAME}`;
export const SHOW_NOTIFICATION_ICON_GLOBAL_TRAY = `SHOW_NOTIFICATION_ICON_GLOBAL_TRAY ${NAME}`;
export const HIDE_NOTIFICATION_ICON_GLOBAL_TRAY = `HIDE_NOTIFICATION_ICON_GLOBAL_TRAY ${NAME}`;
export const ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS = `ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS ${NAME}`;
export const REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS = `REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS ${NAME}`;
export const SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS = `SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS ${NAME}`;
export const SET_AUDIO_RECORDER_ACTIVE =
  "SET_AUDIO_RECORDER_ACTIVE" + " " + NAME;
export const SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE =
  "SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE" + " " + NAME;
export const SET_BADGE_OPTIMISTIC_STATE =
  "SET_BADGE_OPTIMISTIC_STATE" + " " + NAME;

export const SET_IS_RESOURCE_UNAVAILABLE =
  "SET_IS_RESOURCE_UNAVAILABLE" + " " + NAME;

export const SET_PLATFORM_SWITCHER_TAB = `SET_PLATFORM_SWITCHER_TAB ${NAME}`;

export const GENERIC_TAGS_INFO = {
  SL: {
    color: "teal",
    textColor: colors.decorativeSurfaceFiveD,
  },
  HL: {
    color: "pink",
    textColor: colors.decorativeSurfaceFourD,
  },
};
export const GRADING_PERIODS_INFO = {
  REPORTING: {
    labelLocale: "common:reporting_period",
    color: "teal",
  },
  EXAM: {
    labelLocale: "common:exam",
    color: "teal",
  },
  CUMULATIVE: {
    labelLocale: "common:cumulative_period",
    color: "pink",
  },
};
export const AI_USER_ROLES_INFO = {
  system: {
    labelLocale: "common:system",
    color: colors.pink400,
  },
  user: {
    labelLocale: "common:user",
    color: colors.yellow400,
  },
  assistant: {
    labelLocale: "common:assistant",
    color: colors.violet400,
  },
  tool: {
    labelLocale: "common:school_setup_tools",
    color: colors.textSubtle,
  },
};
export const SIZE = [
  {
    type: "group",
    label: "Group",
    locale: "common:group",
  },
  {
    type: "indi",
    label: "Individual",
    locale: "common:indi",
  },
];
export const EVALUATION_METHOD = [
  {
    type: "teacher",
    label: "Teacher Evaluation",
    locale: "common:teacher_evaluation",
  },
  {
    type: "self",
    label: "Self Evaluation",
    locale: "common:self_evaluation",
  },
  {
    type: "peer",
    label: "Peer Evaluation",
    locale: "common:peer_evaluation",
  },
];

//TODO: move this into template at Organization level
export const EVALUATE_PLANNER_ELEMENTS_BY_CURRICULUM = {
  [CURRICULUM_TYPE_PYP]: [
    {
      label: "Approaches to Learning",
      localeLabel: "common:atls_label",
      value: "atls",
    },
    {
      label: "Learning Outcomes",
      localeLabel: "common:benchmarks_label",
      value: "benchmarks",
    },
    {
      label: "Concepts",
      localeLabel: "planningInsights:concepts",
      value: "concepts",
    },
    {
      label: "Learner Profile",
      localeLabel: "planningInsights:lpa",
      value: "lp",
    },
  ],
  [CURRICULUM_TYPE_UBD]: [
    {
      label: "UBD Learning Standards",
      localeLabel: "common:sns",
      value: "learningStandardUBD",
    },
    {
      label: "UBD Skills",
      localeLabel: "common:ubd_skills",
      value: "atlsUBD",
    },
  ],
  [CURRICULUM_TYPE_MYP]: [
    {
      label: "Subject Standard",
      localeLabel: "common:sns",
      value: "learningStandardMYP",
    },
    {
      label: "Approaches to learning",
      localeLabel: "common:atls_label",
      value: "atlsMYP",
    },
    {
      label: "Learner Profile",
      localeLabel: "planningInsights:lpa",
      value: "lpMYP",
    },
  ],
  [CURRICULUM_TYPE_DP]: [
    {
      label: "Subject Standard",
      localeLabel: "common:sns",
      value: "subjectStandardDP",
    },
    {
      label: "Approaches to learning",
      localeLabel: "common:atls_label",
      value: "atlDP",
    },
    {
      label: "Learner Profile",
      localeLabel: "planningInsights:lpa",
      value: "learnerProfileDP",
    },
  ],
};
export const DESIGNATION_CONSTANTS_MAP = {
  TEACHER: { id: "1" },
  CURRICULUM_COORDINATOR: { id: "2" },
  IT_SPECIALIST: { id: "3" },
  SCHOOL_ADMIN: { id: "4" },
};
export const DESIGNATIONS_CONSTANTS = [
  {
    title: "Teacher",
    subText: "Can only access information related to their classes",
    locale: "schoolSetup:desig_1_title",
    subTextLocale: "schoolSetup:desig_1_subText",
    id: 1,
  },
  {
    title: "PYP Coordinator",
    subText:
      "Can access information for all classes and configure school settings",
    locale: "schoolSetup:desig_2_title",
    subTextLocale: "schoolSetup:desig_2_subText",
    id: 2,
  },
  {
    title: "IT Specialist",
    subText:
      "Can access information for all classes and configure school settings",
    locale: "schoolSetup:desig_3_title",
    subTextLocale: "schoolSetup:desig_3_subText",
    id: 3,
  },
  {
    title: "School Administrator",
    subText:
      "Can access information for all classes and configure school settings",
    locale: "schoolSetup:desig_4_title",
    subTextLocale: "schoolSetup:desig_4_subText",
    id: 4,
  },
  {
    title: "Other",
    subText: "Can access information only related to their classes",
    locale: "schoolSetup:desig_5_title",
    subTextLocale: "schoolSetup:desig_5_subText",
    id: 5,
  },
];
export const DESIGNATION_IDS_MAP = {
  TEACHER: 1,
  CURRICULUM_COORDINATOR: 1,
  IT_SPECIALIST: 3,
  SCHOOL_ADMIN: 4,
  OTHER: 5,
  VISITOR: 7,
};
export const ATTENDANCE_GLOBAL_CONSTANTS = Object.freeze({
  ROUTINE_MODE: "ROUTINE_MODE",
  NO_OF_DAYS_IN_ROTATION_CYCLE: "NO_OF_DAYS_IN_ROTATION_CYCLE",
  COUNT_HOLIDAYS_AS_ROTATION_DAY: "COUNT_HOLIDAYS_AS_ROTATION_DAY",
  ATTENDANCE_RECORDING_TYPE: "ATTENDANCE_RECORDING_TYPE",
  DAILY_ATTENDANCE_RECORDING_TYPE: "DAILY_ATTENDANCE_RECORDING_TYPE",
  OPERATIONAL_DAYS: "OPERATIONAL_DAYS",
  ROTATION_CYCLE: "ROTATION_CYCLE",
  SCHEDULER_TIME: "SCHEDULER_TIME",
  STAFF: "staff",
  PARENT: "parent",
  STUDENT: "student",
  HOLIDAYS_AND_VACATIONS: "HOLIDAYS_AND_VACATIONS",
  ATTENDANCE_AUTO_MARKING: "ATTENDANCE_AUTO_MARKING",
  ATTENDANCE_AUTO_MARKING_TIME: "ATTENDANCE_AUTO_MARKING_TIME",
  ENABLE_ATTENDANCE_AUTO_MARKING: "ENABLE_ATTENDANCE_AUTO_MARKING",
  OVERALL_ATTENDANCE_PERCENTAGE_TYPE: "OVERALL_ATTENDANCE_PERCENTAGE_TYPE",
  ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER:
    "ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER",
  ATTENDANCE_OVERALL_PRESENCE_SCORE_CALCULATION:
    "ATTENDANCE_OVERALL_PRESENCE_SCORE_CALCULATION",
  HOMEROOM_PERIOD_ATTENDANCE_SYNC_TYPE: "HOMEROOM_PERIOD_ATTENDANCE_SYNC_TYPE",
  ATTENDANCE_RECORDING_FROM_DATE: "ATTENDANCE_RECORDING_FROM_DATE",
  OVERRIDE_LINK_PERIOD_FOR_BELL_SCHEDULE:
    "OVERRIDE_LINK_PERIOD_FOR_BELL_SCHEDULE",
});
export const THIRD_PARTY_REDIRECT_GLOBAL_CONSTANTS = Object.freeze({
  THIRD_PARTY_REDIRECT_URL_CONFIG: "THIRD_PARTY_REDIRECT_URL_CONFIG",
});

//never write to prototype
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.allCapitalize = function () {
  return this.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

Array.prototype.last = function () {
  return this[this.length - 1];
};

String.prototype.camelize = function () {
  const str = this;
  return str.replace(/\W+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
};

Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

Number.prototype.between = function (a, b) {
  var min = Math.min.apply(Math, [a, b]),
    max = Math.max.apply(Math, [a, b]);
  return this > min && this < max;
};

Array.prototype.lastNth = function (n) {
  return this[this.length - n];
};

Array.prototype.firstNth = function (n) {
  return this[n - 1];
};

Array.prototype.first = function () {
  return this[0];
};

Array.prototype.next = function ({ current, findKey }) {
  let index = _.indexOf(this, current);
  if (findKey) {
    index = _.findIndex(this, { [findKey]: current });
  }
  return this[index + 1];
};

Array.prototype.previous = function ({ current, findKey }) {
  let index = _.indexOf(this, current);
  if (findKey) {
    index = _.findIndex(this, { [findKey]: current });
  }
  return this[index - 1];
};
// Array.from = function(what, n, step) {
//   var A = [];
//   if (arguments.length) {
//     if (n) {
//       return A.range(what, n, step);
//     }
//     L = what.length;
//     if (L) {
//       while (L) {
//         A[--L] = what[L];
//       }
//       return A;
//     }
//     if (what.hasOwnProperty) {
//       for (var p in what) {
//         if (what.hasOwnProperty(p)) {
//           A[A.length] = what[p];
//         }
//       }
//       return A;
//     }
//   }
//   return A;
// };

Array.prototype.range = function (what, n, step) {
  this[this.length] = what;
  if (what.split && n.split) {
    what = what.charCodeAt(0);
    n = n.charCodeAt(0);
    while (what < n) {
      this[this.length] = String.fromCharCode(++what);
    }
  } else if (isFinite(what)) {
    step = step || 1;
    while (what < n) this[this.length] = what += step;
  }
  return this;
};

Array.prototype.toggleValues = function (values = []) {
  const sourceArray = this;

  const addedValues = _.filter(
    values,
    value => !_.includes(sourceArray, value)
  );

  const remainingValues = _.filter(
    sourceArray,
    value => !_.includes(values, value)
  );

  return [...remainingValues, ...addedValues];
};
